module.exports = __webpack_public_path__ + "img/vk-logo.ab972c94.png";